<template lang="html">
  <div class="mng-editor-content">
    <div class="mng-editor-panel">
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          首入方式
        </div>
        <el-radio v-model="entryMode" label="3d" disabled>
          3D空间
        </el-radio>
        <el-radio v-model="entryMode" label="pano">
          全景空间
        </el-radio>
      </div>
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          点位样式
        </div>
        <div class="editor-panel-markers">
          <div v-for="pointStyle in pointStyles"
               :key="pointStyle.id"
               class="editor-panel-markers__marker"
               :class="{
                 'editor-panel-markers__marker--selected':
                   selectedPointStyle && pointStyle.id === selectedPointStyle.id
               }"
               @click="onSelectPoint(pointStyle)">
            <img v-if="pointStyle && pointStyle.icon"
                 :src="pointStyle.icon"
                 class="editor-panel-markers__icon">
          </div>
          <div class="editor-panel-markers__marker editor-panel-markers__marker--add">
            <img src="@/assets/views/models/plus.png"
                 class="editor-panel-markers__icon"
                 @click="selectPoint">
            <input ref="uploader"
                   type="file"
                   class="editor-panel-markers__uploader"
                   accept="image/*"
                   @change="getNewPointStyle">
          </div>
        </div>
      </div>
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          初始视角
        </div>
        <div class="switch-item">
          <el-switch v-model="viewEditable" />
          <span>开启后可定义初始视角</span>
        </div>
      </div>
      <div class="mng-editor-panel__block mng-editor-panel__block--last">
        <div class="mng-editor-panel__label">
          可视范围
        </div>
        <div class="switch-item">
          <el-input v-model.number="visibleRadius" />
        </div>
        <div class="mng-editor-panel__label">
          点位管理
        </div>
        <div class="switch-item">
          <el-switch v-model="pointEditable" @change="onPointEditableChange" />
          <span>开启后, 右击点位切换隐藏与显示</span>
        </div>
         <div class="mng-editor-panel__label">
        </div>
        <div class="mng-editor-panel__label">
          点位相互隐藏
        </div>
        <div class="switch-item">
          <el-switch v-model="pointEditable2" @change="onPointEditableChange2" />
          <span>开启后, 右击点位切换隐藏与显示</span>
        </div>
      </div>

    </div>
    <div class="mng-vr-scene">
      <VrScene ref="vrScene"
               class="mng-vr-scene__stage"
               :visible-radius.sync="visibleRadius"
               :sceneId="$route.params.modelId"
               @pano-icon-right-click="onPointClicked"
               @initialized="loadPanoramaIcons" />
      <div class="panorama-jump-panel">
        <el-input v-model.number="panId" placeholder="全景点ID" />
        <el-button @click="moveToPanoramID">跳转</el-button>
      </div>
      <transition name="fade" mode="out-in" appear>
        <div v-if="viewEditable" class="frame-support">
          <div :style="frameStyle" class="frame-support__frame">
            <div class="frame-support__corner frame-support__corner--topleft" />
            <div class="frame-support__corner frame-support__corner--topright" />
            <div class="frame-support__corner frame-support__corner--bottomleft" />
            <div class="frame-support__corner frame-support__corner--bottomright" />
          </div>
        </div>
      </transition>
      <div class="mng-vr-scene__actions">
        <transition name="fade" mode="out-in" appear>
          <div v-if="viewEditable"
               class="ai-button ai-button--primary mng-vr-scene__button"
               style="min-width: 169px;"
               @click="updateInitialView">
            更新初始视角
          </div>
        </transition>
        <transition name="fade" mode="out-in" appear>
          <span v-if="pointEditable" style="min-width: 125px;">右键点击点位切换显示</span>
           <span v-if="pointEditable2" style="min-width: 125px;">右键点击点位切换相互显示/隐藏</span>

        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import VrScene from '@/components/ai-vr-scene.vue';
// import VrScene from '@/components/owllySence/VrScene';


export default {
  components: {
    VrScene
  },
  data() {
    return {
      entryMode: 'pano',
      pointEditable: false,
      pointEditable2: false,
      viewEditable: false,
      frameStyle: {
        height: 0,
        width: 0
      },
      visibleRadius: 15,
      pointStyles: [],
      selectedPointStyle: null,
      panId: null
    };
  },
  mounted() {
    // this.loadPanoramaIcons();
    window.addEventListener('resize', this.updateFrame);
    this.updateFrame();
  },
  beforeDestroy() {
    // do something before destroying vue instance
    window.removeEventListener('resize', this.updateFrame);
  },
  methods: {
    updateFrame() {
      const scene = this.$refs.vrScene.$el;
      this.frameStyle = {
        height: `${scene.clientHeight - 16}px`,
        width: `${(scene.clientHeight - 16) * 0.5625}px`
      };
    },
    onPointEditableChange(editable) {
      this.pointEditable2 = false;
      if (editable) this.$refs.vrScene.setShowMode('edit');
      else this.$refs.vrScene.setShowMode('normal');
    },
    onPointEditableChange2(editable){
      this.pointEditable = false;
      if (editable) this.$refs.vrScene.setShowMode('edit');
      else this.$refs.vrScene.setShowMode('normal');
    },
    async loadPanoramaIcons() {
      const { data: { data: { panorama_icons: panoramaIcons } } } = await this.$http.post(
        '/v1/list-brand-panorama-icons',
        { store_id: this.$route.params.modelId }
      );
      console.log('[[[[[[[[[[[[[[[',panoramaIcons);
      this.$refs.vrScene.setPanoramaIcons(panoramaIcons);
      this.pointStyles = panoramaIcons;
      this.getStoreInfo();
    },
    async onPointClicked({ panoramaId, visible }) {
      if (this.pointEditable)
      {
          try {
            await this.$http.post(
              '/admin/modify-panorama?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
              {
                // store_id: 1,
                store_id: this.$route.params.modelId,
                panorama_id: panoramaId,
                visible: !visible
              }
            );
            this.$refs.vrScene.setPanoramaVisibility(panoramaId, !visible);
            // eslint-disable-next-line camelcase
            const { data: { data } } = await this.$http.get(`/admin/list-panoramas/${this.$route.params.modelId}`);
            // eslint-disable-next-line camelcase
            this.$eventReport({
              event: 'node_value', node: 'point_hidden_amount', data: data.total_count - data.visible_count, vr_id: this.$route.params.modelId
            });// 点位隐藏量总量
          } catch (error) {
            this.$log(error.error_msg || error);
          }
      }

      if(this.pointEditable2)
      {
          console.log('第二',panoramaId,visible,this.$refs.vrScene.getCurrentPanoramaId());
          try {
            await this.$http.post(
              '/admin/modifyPanoVisibleIds',
              {
                vr_id: this.$route.params.modelId,
                from_pano:Number(this.$refs.vrScene.getCurrentView().panoramaId),
                to_pano: Number(panoramaId),
                visible: Number(!visible)
              }
            );
            await this.$http.post(
              '/admin/modifyPanoVisibleIds',
              {
                vr_id: this.$route.params.modelId,
                from_pano:Number(panoramaId),
                to_pano: Number(this.$refs.vrScene.getCurrentView().panoramaId),
                visible: Number(!visible)
              }
            );

            // this.$refs.vrScene.setPanoramaVisibility(panoramaId, !visible);
          }catch (error) {
            this.$log(error.error_msg || error);
          }
      }
    },
    async updateInitialView() {
      const { direction: { x, y, z }, panoramaId } = this.$refs.vrScene.getCurrentView();
      try {
        await this.$http.post(
          '/admin/modify-store-initial-view?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            panorama_id: panoramaId,
            direction_x: x,
            direction_y: y,
            direction_z: z
          }
        );
        this.$message('修改成功');
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    onSelectPoint(pointStyle) {
      if (pointStyle !== this.selectedPointStyle) {
        this.changeStorePointStyle(pointStyle);
      }
    },
    selectPoint() {
      this.$refs.uploader.click();
    },
    getNewPointStyle() {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.createPointStyle(fileReader.result);
      }, false);
      const file = this.$refs.uploader.files[0];
      if (file) {
        // eslint-disable-next-line
        const size = file.size / Math.pow(1024, 2);
        if (file.size > 2) {
          this.$message('图片尺寸大于2M,请重新选择');// eslint-disable-next-line
          return;// eslint-disable-next-line
        } // eslint-disable-next-line
        else {
          fileReader.readAsDataURL(file);
        }
      }
    },
    async createPointStyle(image) {
      try {
        const { data } = await this.$http.post(
          '/admin/add-panorama-icon?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            panorama_icon: image.replace(/data:image.*?,/gi, '')
          }
        );
        console.log(data);
        if (data.error_no === 200) {
          this.$message('添加成功');
          // this.$refs.vrScene.loadPtStyle();
          this.loadPanoramaIcons();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    onPointStyleLoaded({ ptStyle }) {
      this.pointStyles = ptStyle;
      if (this.selectedPointStyle) {
        this.selectedPointStyle = this.pointStyles.find(p => p.id === this.selectedPointStyle.id);
      } else {
        this.getStoreInfo();
      }
    },
    async getStoreInfo() {
      try {
        const { data: { data } } = await this.$http.post(
          '/admin/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          { store_id: this.$route.params.modelId }
        );
        this.selectedPointStyle = this.pointStyles.find(p => p.id === data.panorama_icon_id);
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    async changeStorePointStyle(pointStyle) {
      // this.$refs.vrScene.loadPanoramaIcons();
      try {
        const { data } = await this.$http.post(
          '/admin/modify-store-panorama-icon?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            icon_id: pointStyle.id
          }
        );
        if (data.error_no === 200) {
          this.$message('修改成功');
          this.selectedPointStyle = pointStyle;
          // this.$refs.vrScene.loadPanoramaIcons();
          this.$refs.vrScene.setPanoramaIcon(pointStyle.id);
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    // 跳转到指定全景点ID
    moveToPanoramID() {
      if (!this.panId) return;
      this.$refs.vrScene.moveToPanoramID(this.panId);
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-jump-panel {
  z-index: 100;
  position: fixed;
  top: 64px;
  right: 0;
  display: flex;
  gap: 8px;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.switch-item {
  display: flex;
  align-items: center;

  span {
    margin-left: 7px;
    font-size: 12px;
    color: #666;
  }
}

.frame-support {
  top: 80px;
  left: 85px;
  width: calc(100% - 170px);
  height: calc(100% - 210px);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;

  &__frame {
    border: 2px dashed #fff;
    position: relative;
  }

  &__corner {
    width: 50px;
    height: 50px;
    position: absolute;

    &--topleft {
      top: -4px;
      left: -4px;
      border-top: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--topright {
      top: -4px;
      right: -4px;
      border-top: 6px solid #fff;
      border-right: 6px solid #fff;
    }

    &--bottomleft {
      bottom: -4px;
      left: -4px;
      border-bottom: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--bottomright {
      bottom: -4px;
      right: -4px;
      border-bottom: 6px solid #fff;
      border-right: 6px solid #fff;
    }
  }
}

.editor-panel-markers {
  display: flex;

  &__marker {
    height: 28px;
    width: 28px;
    border-radius: 2px;
    background-color: #d8d8d8;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    cursor: pointer;

    &--add {
      background-color: transparent;
      border: 1px solid #999;
      height: 26px;
      width: 26px;
    }

    img {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }

    &--selected {
      border: 2px solid #a9a9a9;
      height: 24px;
      width: 24px;
    }
  }

  &__uploader {
    visibility: hidden;
    position: absolute;
    height: 0;
    width: 0;
    display: inline-block;
  }
}
</style>
